import { useCallback } from 'react';

import { useTheme } from '@mui/material';
import type { Palette } from '@mui/material';

import type { ColorEnum } from '@e-socna/data-layer';

import { colorToMuiColor as colorMap } from '../utils/color-to-mui-color.util';

export const useColorToMuiColor = (
  defaultColor: string | ((palette: Palette) => string) = (palette) =>
    palette.mode === 'light' ? palette.grey[300] : palette.grey[800],
) => {
  const { palette } = useTheme();

  const colorToMuiColor = useCallback(
    (color: ColorEnum) => {
      const muiColor = colorMap(color);

      const defaultValue =
        typeof defaultColor === 'function'
          ? defaultColor(palette)
          : defaultColor;

      return muiColor !== 'default' ? palette[muiColor].main : defaultValue;
    },
    [defaultColor, palette],
  );

  return { colorToMuiColor };
};
